import React from "react";
import InsightScoreWidgets from "./InsightScoreWidgets";
import InsightSpeedometer from "./InsightSpeedometer";
import InsightTabs from "./InsightTabs";
import "./InsightPreview.scss";
import ScoreWidgets from "../../../assets/images/score-widget.png";
import Toggle from "../../../assets/images/toggle.png";
import Speedometer from "../../../assets/images/speedo.png";

const InsightDashboardPreview = ({ insightConfig, reportConfiguration }) => {
    if (!insightConfig) {
        return (
            <div className="text-muted text-center mt-5">
                Select Insight from left menu to preview dashboard
            </div>
        );
    }

    return (
        <div className="insight-dashboard-preview">
            {reportConfiguration?.average_toggle && (
                // <InsightScoreWidgets preview />
                <div className="d-flex" style={{ justifyContent: 'end' }}>
                    <img alt="" src={Toggle} className="dashboard-preview-img" style={{ width: '90px', height: "40px", objectFit: 'cover' }} />
                </div>
            )}
            {/* 🔹 Score widgets */}
            {insightConfig.score_widgets && (
                // <InsightScoreWidgets preview />
                <img alt="" src={ScoreWidgets} className="dashboard-preview-img w-100" />
            )}

            {/* 🔹 Speedometer */}
            {(insightConfig.speedometer || insightConfig.tabs?.length > 0) && (
                <div className="row mt-4">

                    {/* LEFT: Speedometer */}
                    {insightConfig.speedometer && (
                        <div className="col-md-5">
                            {/* <InsightSpeedometer /> */}
                            <img alt="" src={Speedometer} className="dashboard-preview-img w-100" />
                        </div>
                    )}

                    {/* RIGHT: Tabs */}
                    {insightConfig.tabs?.length > 0 && (
                        <div className="col-md-7">
                            <InsightTabs tabs={insightConfig.tabs} />
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};

export default InsightDashboardPreview;